import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"text-align":"right","margin-bottom":"20px"} }
const _hoisted_2 = { style: {"display":"flex","justify-content":"center","align-items":"center"} }

import { reactive, ref, onMounted, unref } from 'vue';
import { ElButton, ElTag } from 'element-plus';
import { GbTables } from '@/components/GbTables';
import { MainstayDialog, StampListDialog } from './components/Index';
import { useGbTable } from '@/hooks/useGbTable';
import { useLocales } from '@/hooks/useLocales';
import { useDictionary } from '@/store/dictionary.store';
import { GetMainstayListApi, MainstayDelApi } from '@/apis/basics/mainstay.api';
import { TableColumn } from '@/components/GbTables/GbTablesTypes';
import moment from 'moment';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const dialogRef = ref<ComponentRef<typeof MainstayDialog>>();
const stampRef = ref<ComponentRef<typeof StampListDialog>>();

/* GbTable 配置 */
const { register, tableObject, methods } = useGbTable<any>({
	getListApi: GetMainstayListApi,
	delListApi: MainstayDelApi,
	response: { data: 'data', total: 'total' },
});

const { t } = useLocales();
const { setSearchParams } = methods;
const { getName } = useDictionary();

const state = reactive({
	loading: false,
	search: { part_type_id: '', tenant_id: '1' } as any,
	paged: { current: 1, page_size: 20 },
});

/* 数据Table绑定设置 */
const tabColumns = reactive<TableColumn[]>([
	{ field: 'code', label: t('mainstay.table.code', '编号'), columnWidth: '100' },
	{ field: 'name_cn', label: t('mainstay.table.name', '名称'), columnWidth: '250' },
	{ field: 'short_name', label: t('mainstay.table.shortName', '缩写'), columnWidth: '200' },
	{ field: 'remark', label: t('mainstay.table.remark', '备注') },

	{ field: 'reg_nation', label: t('mainstay.table.regNation', '注册国家'), columnWidth: '80', align: 'center' },
	{ field: 'reg_day', label: t('mainstay.table.regDate', '注册日期'), columnWidth: '100', align: 'center' },
	{ field: 'business_status', label: t('mainstay.table.businessStatus', '经营状态'), columnWidth: '80', align: 'center' },

	{ field: 'is_enabled', label: t('mainstay.table.status', '状态'), columnWidth: '80', align: 'center' },
	// { field: 'sort', label: '排序', columnWidth: "80", align: 'center' },
	{ field: 'created_time', label: t('mainstay.table.createdDate', '创建日期'), columnWidth: '120', fixed: 'right', align: 'center' },
	{ field: 'action', width: '120px', label: t('mainstay.table.action', '操作'), fixed: 'right', align: 'center' },
]);

const rowPreViewAcion = (rowID: string) => {
	// push(`/contract/detail?contractId=${rowID}`)
};

const actions = {
	search: () => {
		const searchInput = Object.assign({}, state.search, state.paged);
		methods.setSearchParams(searchInput);
	},
	reSetSearch: () => {
		state.search = {};
		methods.resetParams(state.search);
	},
	/* 创建 */
	creaetActions: () => {
		unref(dialogRef)?.showDialog('', false);
	},

	/* 编辑 */
	editActions: (rowId: string) => {
		unref(dialogRef)?.showDialog(rowId, true);
	},

	/* 打开印章管理 */
	showStampDialog: (rowId: string) => {
		unref(stampRef)?.showDialog(rowId);
	},

	/* 删除记录 */
	deleteActions: (row: any) => {
		const delData = { id: row.id, revision: row.revision };
		methods.deleteRows(delData);
	},
};

onMounted(async () => {
	tableObject.pageSize = 20;
	actions.search();
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button_group = _resolveComponent("el-button-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_More = _resolveComponent("More")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, {
      shadow: "never",
      "body-style": { paddingBottom: '0' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          size: "small",
          model: _unref(state).search,
          inline: true
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              "label-width": '80px',
              label: _unref(t)('mainstay.form.mainstayCode', '主体编号')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "text",
                  modelValue: _unref(state).search.code,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).search.code) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              "label-width": '80px',
              label: _unref(t)('mainstay.form.mainstayName', '主体名称')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "text",
                  modelValue: _unref(state).search.name_cn,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).search.name_cn) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button_group, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElButton), {
                      icon: "Refresh",
                      onClick: actions.reSetSearch
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('buttons.reset', '重置')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_unref(ElButton), {
                      type: "primary",
                      icon: "Search",
                      onClick: actions.search
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('buttons.search', '查询')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, {
      shadow: "never",
      style: {"margin-top":"10px"},
      disabled: _unref(tableObject).loading
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_unref(ElButton), {
            size: "small",
            type: "warning"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('mainstay.buttons.syncData', '同步数据')), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(ElButton), {
            size: "small",
            type: "primary",
            onClick: actions.creaetActions
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('mainstay.buttons.addMainstay', '新增主体')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createVNode(_unref(GbTables), {
          pageSize: _unref(tableObject).pageSize,
          "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => ((_unref(tableObject).pageSize) = $event)),
          currentPage: _unref(tableObject).currentPage,
          "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => ((_unref(tableObject).currentPage) = $event)),
          columns: _unref(tabColumns),
          data: _unref(tableObject).tableList,
          loading: _unref(tableObject).loading,
          pagination: { total: _unref(tableObject).total },
          onRegister: _unref(register)
        }, {
          is_enabled: _withCtx(({ row }) => [
            (row.is_enabled == 'Y')
              ? (_openBlock(), _createBlock(_unref(ElTag), {
                  key: 0,
                  type: "success",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('status.enabled', '启用')), 1)
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_unref(ElTag), {
                  key: 1,
                  type: "danger",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('status.diabled', '停用')), 1)
                  ]),
                  _: 1
                }))
          ]),
          created_time: _withCtx(({ row }) => [
            _createElementVNode("span", null, _toDisplayString(_unref(moment)(row.created_time).format('YYYY-MM-DD HH:mm')), 1)
          ]),
          reg_day: _withCtx(({ row }) => [
            _createElementVNode("span", null, _toDisplayString(_unref(moment)(row.reg_day).format('YYYY-MM-DD')), 1)
          ]),
          reg_nation: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_unref(getName)('nation', row.reg_nation)), 1)
          ]),
          business_status: _withCtx(({ row }) => [
            _createVNode(_unref(ElTag), {
              type: "info",
              size: "small"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(getName)('business_status', row.business_status)), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          action: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(ElButton), {
                size: "small",
                type: "success",
                link: "",
                onClick: ($event: any) => (actions.editActions(row.id))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('mainstay.buttons.edit', '编辑')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_dropdown, {
                size: "small",
                style: {"padding":"2px","margin-left":"12px"},
                trigger: "click"
              }, {
                dropdown: _withCtx(() => [
                  _createVNode(_component_el_dropdown_menu, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_dropdown_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ElButton), {
                            size: "small",
                            type: "info",
                            link: "",
                            onClick: ($event: any) => (actions.showStampDialog(row.id))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('mainstay.buttons.stampManagement', '印章管理')), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_dropdown_item, { divided: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ElButton), {
                            size: "small",
                            type: "danger",
                            link: "",
                            onClick: ($event: any) => (actions.deleteActions(row))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('mainstay.buttons.deleteMainstay', '删除主体')), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_More)
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1024)
            ])
          ]),
          _: 1
        }, 8, ["pageSize", "currentPage", "columns", "data", "loading", "pagination", "onRegister"])
      ]),
      _: 1
    }, 8, ["disabled"]),
    _createVNode(_unref(MainstayDialog), {
      ref_key: "dialogRef",
      ref: dialogRef,
      onRefresh: actions.search
    }, null, 8, ["onRefresh"]),
    _createVNode(_unref(StampListDialog), {
      ref_key: "stampRef",
      ref: stampRef
    }, null, 512)
  ], 64))
}
}

})